import { Auth, LoginDetails } from '@util/Auth';
import { AuthValidation } from '@util/AuthValidation';
import { ApiClient } from '../../../api/ApiClient';
import { addUserToAvailableHcpReferral } from '../../../helpers/HcpReferrals';
import { ActionType } from '../../ActionTypes';
import { store as baseStore } from '../../Store';
import { handleUserError, surveyCompletedAction, validateUserIsNotAuthenticated } from '../Utils';

/** Logs a user in and updates the user and userData state with the result. */
export async function loginUser(details: LoginDetails, store = baseStore): Promise<void> {
  try {
    store.dispatch({ type: ActionType.LOGIN_USER_LOADING });

    validateUserIsNotAuthenticated();
    AuthValidation.validateLogin(details);

    const apiClient = new ApiClient();
    const { user, userData } = await Auth.signInUser(details);
    const { paid: hasPaid } = await apiClient.userHasPaid();

    await addUserToAvailableHcpReferral();

    store.dispatch({
      type: ActionType.LOGIN_USER_SUCCESS,
      user: { ...user, hasPaid, setUserPassword: false },
      userData,
      method: 'token' in details ? 'token' : 'emailAndPassword',
    });

    store.dispatch(surveyCompletedAction());
  } catch (rawError) {
    const error = handleUserError(rawError);
    store.dispatch({ type: ActionType.LOGIN_USER_FAILURE, error });
  }
}
